import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { KeyRound } from "lucide-react";
import { defineModuleUi, from, unwrap, useOrg } from "@vixio/data";
import { StatusFromMap, formatDate, lazyPage } from "@vixio/ui";
import "./api";
import { ALERT } from "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const VaultPage = lazyPage(() => import("./VaultPage"), "VaultPage");
const ItemPage = lazyPage(() => import("./ItemPage"), "ItemPage");

function ExpiringWidget() {
  const org = useOrg();
  const q = useQuery({
    queryKey: ["credentials", "widget", org.id],
    queryFn: () =>
      unwrap<Array<{ id: string; title: string; alert_state: string; expires_at: string | null }>>(
        from("credentials", "v_items").select("id, title, alert_state, expires_at").eq("org_id", org.id)
          .in("alert_state", ["vencida", "vence_em_breve", "rotacao_atrasada", "rotacao_em_breve"]).order("expires_at", { nullsFirst: false }).limit(5),
      ),
  });
  if (!q.data?.length) return <p className="muted">Nada vencendo no cofre.</p>;
  return (
    <ul className="vx-stack" style={{ gap: 8, margin: 0, padding: 0, listStyle: "none" }}>
      {q.data.map((i) => (
        <li key={i.id} className="vx-row vx-row--between" style={{ flexWrap: "nowrap" }}>
          <span style={{ minWidth: 0 }}>
            <Link to={`/documentos/cofre/${i.id}`}>{i.title}</Link>
            {i.expires_at ? <span className="text-2 num"> · {formatDate(i.expires_at)}</span> : null}
          </span>
          <StatusFromMap map={ALERT} value={i.alert_state} />
        </li>
      ))}
    </ul>
  );
}

export default defineModuleUi({
  key: "credentials",
  title: "Cofre",
  domain: "documents",
  icon: KeyRound,
  menu: [{ path: "/documentos/cofre", label: "Cofre", minRole: "member", icon: KeyRound, order: 40, keywords: "senha credencial acesso segredo chave api revelar" }],
  routes: [
    { path: "/documentos/cofre", element: <VaultPage />, minRole: "member" },
    { path: "/documentos/cofre/:id", element: <ItemPage />, minRole: "member" },
  ],
  widgets: [{ key: "credentials.expiring", title: "Cofre: vencimentos", minRole: "member", span: 1, order: 80, element: ExpiringWidget }],
});
